// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseChecker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------


/**
 * LicenseChecker component
 */
!(function () {

  var classnames = require('classnames');

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');

  var DatabaseConfiguration = require('./Izenda.DatabaseConfiguration');
  var LicenseValidation = require('./Izenda.LicenseValidation');
  var LicenseInfo = require('./Izenda.LicenseInfo');
  var ProvisioningMapData = require('./Izenda.ProvisioningMapData');
  var SystemModeSetting = require('./Izenda.SystemModeSetting');

  var LicenseChecker = React.createClass({

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentDidMount: function () {
      var loader = this.props.loader;
      loader.startLoading();
      return this.props.store
        .getInitData()
        .finally(loader.endLoading.bind(loader));
    },

    render: function () {
      var store = this.props.store;
      var licenseInfo = store.licenseInfoStore.licenseInfo;
      var isShowProvisioning = licenseInfo.hasMapModules;
      var hasSetupDatabase = this.props.hasSetupDatabase;

      return (
        <ScrollBox shouldInjectScrollCallbackToChild={false}>
          <section className='u_fullHeight'>

            <div className="izenda-LicenseChecker-iconMenu">
              <IconMenu />
            </div>

            <DatabaseConfiguration store={store} />

            {renderLicenseSection()}

          </section>
        </ScrollBox>
      );

      function renderLicenseSection () {
        return hasSetupDatabase
        ? (
        <div>
          <LicenseValidation
              store={store.licenseInfoStore}
              item={licenseInfo}
              isValidConnection={store.databaseConfiguration.isValidConnection}
              validatedConnection={store.databaseConfiguration.validatedConnection} />

          <LicenseInfo
            item={licenseInfo}
            store={store.licenseInfoStore}
            validatedConnection={store.databaseConfiguration.validatedConnection} />
          <SystemModeSetting store={store} />
          {isShowProvisioning && <ProvisioningMapData />}
            </div>)
        : null;
      }
    }
  });

  module.exports = connect()(LicenseChecker);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.LicenseChecker.jsx